import {
  CloseModalButton,
  PrimaryButton,
  SecondaryButton
} from '@library/components/buttons';
import { Modal } from '@library/components/modals/Modal';
import { classNames } from '@library/utils';

export interface MemberConfirmationModalProps {
  cancelCopy?: string;
  children: React.ReactNode;
  childrenClassName?: string;
  className?: string;
  confirmationCopy?: string;
  handleConfirm: () => Promise<void> | void;
  isButtonDisabled?: boolean;
  isConfirmDisabled?: boolean;
  isOpen: boolean;
  label: string;
  onCancelModal: () => void;
  showConfirmationMessage?: boolean;
}

export const MemberConfirmationModal = ({
  cancelCopy = 'Back',
  children,
  childrenClassName = '',
  className = '',
  confirmationCopy = 'Confirm',
  handleConfirm,
  isButtonDisabled = false,
  isConfirmDisabled = false,
  isOpen,
  label,
  onCancelModal,
  showConfirmationMessage = false
}: MemberConfirmationModalProps) => {
  const cancelText = !showConfirmationMessage ? cancelCopy : 'Close';

  return (
    <Modal isOpen={isOpen} onCancelModal={onCancelModal}>
      <div
        className={classNames(
          'bg-soFresh-110 border-soFresh-140 relative mx-auto flex-col rounded-md border',
          className
        )}
      >
        <div className="border-soFresh-140 flex h-16 items-center rounded-t border-b border-solid pl-6">
          <span>{label}</span>
          <CloseModalButton handleOnClick={onCancelModal} />
        </div>
        <div className={classNames('flex flex-col p-6', childrenClassName)}>
          {children}
        </div>
        <div className="border-soFresh-140 flex justify-end gap-4 border-t px-6 py-4">
          <SecondaryButton
            title={cancelText}
            handleOnClick={onCancelModal}
            className="!bg-soFresh-140 min-w-[75px]"
            disabled={isButtonDisabled}
          >
            {cancelText}
          </SecondaryButton>
          {!showConfirmationMessage && (
            <PrimaryButton
              title={confirmationCopy}
              handleOnClick={handleConfirm}
              disabled={isButtonDisabled || isConfirmDisabled}
            >
              {confirmationCopy}
            </PrimaryButton>
          )}
        </div>
      </div>
    </Modal>
  );
};
